
(function() {
  var result = { translations: { "fi": { "SharedI18nStrings": { "languageNames": { "af": "Afrikaans", "sq": "Albania", "sq-al": "Albania \u2013 Albania", "ar": "Arabia", "ar-dz": "Arabia \u2013 Algeria", "ar-bh": "Arabia \u2013 Bahrain", "ar-eg": "Arabia \u2013 Egypti", "ar-iq": "Arabia \u2013 Irak", "ar-jo": "Arabia \u2013 Jordania", "ar-kw": "Arabia \u2013 Kuwait", "ar-lb": "Arabia \u2013 Libanon", "ar-ly": "Arabia \u2013 Libya", "ar-ma": "Arabia \u2013 Marokko", "ar-om": "Arabia \u2013 Oman", "ar-qa": "Arabia \u2013 Qatar", "ar-sa": "Arabia \u2013 Saudi-Arabia", "ar-sd": "Arabia \u2013 Sudan", "ar-sy": "Arabia \u2013 Syyria", "ar-tn": "Arabia \u2013 Tunisia", "ar-ae": "Arabia \u2013 Yhdistyneet arabiemiirikunnat", "ar-ye": "Arabia \u2013 Jemen", "as": "Assami", "az": "Azerbaid\u017Eani", "hy": "Armenia", "eu": "Baski", "be": "Valkoven\xE4j\xE4", "be-by": "Valkoven\xE4j\xE4 \u2013 Valko-Ven\xE4j\xE4", "bn": "Bengali", "bg": "Bulgaria", "bg-bg": "Bulgaria \u2013 Bulgaria", "bs": "Bosnia", "ca": "Katalaani", "ca-es": "Katalaani \u2013 katalaani", "zh": "Kiina", "zh-cn": "Kiina - yksinkertaistettu", "zh-hk": "Kiina - Hong Kong", "zh-mo": "Kiina \u2013 Macao", "zh-sg": "Kiina \u2013 Singapore", "zh-tw": "Kiina - perinteinen", "zh-chs": "Kiina (yksinkertaistettu)", "zh-cht": "Kiina (perinteinen)", "zh-hans": "Kiina (yksinkertaistettu han)", "zh-hant": "Kiina (perinteinen han)", "hr": "Kroatia", "hr-hr": "Kroaatti \u2013 Kroatia", "cs": "T\u0161ekki", "cs-cz": "T\u0161ekki \u2013 T\u0161ekin tasavalta", "da": "Tanska", "da-dk": "Tanska \u2013 Tanska", "nl": "Hollanti", "nl-be": "Hollanti \u2013 Belgia", "nl-ch": "Hollanti - Sveitsi", "nl-lu": "Hollanti \u2013 Luxemburg", "nl-nl": "Hollanti \u2013 Alankomaat", "en": "Englanti", "en-ae": "Englanti \u2013 Yhdistyneet arabiemiirikunnat", "en-au": "Englanti \u2013 Australia", "en-be": "Englanti \u2013 Belgia", "en-ca": "Englanti \u2013 Kanada", "en-ch": "Englanti - Sveitsi", "en-cn": "Englanti \u2013 Kiina", "en-de": "Englanti - Saksa", "en-ee": "Englanti - Viro", "en-es": "Englanti - Espanja", "en-fr": "Englanti - Ranska", "en-hk": "Englanti \u2013 Hong Kong", "en-in": "Englanti \u2013 Intia", "en-ie": "Englanti \u2013 Irlanti", "en-ke": "Englanti \u2013 Kenia", "en-lu": "Englanti \u2013 Luxemburg", "en-my": "Englanti \u2013 Malesia", "en-mt": "Englanti \u2013 Malta", "en-mx": "Englanti - Meksiko", "en-nl": "Englanti - Alankomaat", "en-nz": "Englanti \u2013 Uusi-Seelanti", "en-ph": "Englanti \u2013 Filippiinit", "en-pk": "Englanti \u2013 Pakistan", "en-se": "Englanti - Ruotsi", "en-sg": "Englanti \u2013 Singapore", "en-tn": "Englanti - Tunisia", "en-za": "Englanti \u2013 Etel\xE4-Afrikka", "en-gb": "Englanti \u2013 Yhdistynyt kuningaskunta", "en-us": "Englanti \u2013 Yhdysvallat", "en-zw": "Englanti \u2013 Zimbabwe", "et": "Viro", "et-ee": "Englanti \u2013 Viro", "fo": "F\xE4\xE4ri", "fa": "Persia", "fi": "Suomi", "fi-fi": "Suomi \u2013 Suomi", "fil": "Filippiinil\xE4inen", "fr": "ranska", "fr-be": "Ranska \u2013 Belgia", "fr-ca": "Ranska \u2013 Kanada", "fr-fr": "Ranska \u2013 Ranska", "fr-lu": "Ranska \u2013 Luxemburg", "fr-mc": "Ranska \u2013 Monaco", "fr-ch": "Ranska \u2013 Sveitsi", "fr-tn": "Ranska \u2013 Tunisia", "gl": "Galego", "ka": "Georgia", "de": "saksa", "de-at": "Saksa \u2013 It\xE4valta", "de-de": "Saksa \u2013 Saksa", "de-gr": "Saksa \u2013 Saksa", "de-li": "Saksa \u2013 Liechtenstein", "de-lu": "Saksa \u2013 Luxemburg", "de-ch": "Saksa \u2013 Sveitsi", "el": "Kreikka", "el-cy": "Kreikka \u2013 Kypros", "el-gr": "Kreikka \u2013 Kreikka", "gu": "Gujarati", "haw": "Havaiji", "ha": "Hausa", "he": "Heprea", "he-il": "Heprea \u2013 Israel", "iw-il": "Heprea \u2013 Israel", "hi": "Hindi", "hi-in": "Hindi \u2013 Intia", "hu": "Unkari", "hu-hu": "Unkari \u2013 Unkari", "is": "Islanti", "is-is": "Islanti \u2013 Islanti", "id": "Indonesia", "in-id": "Indonesia \u2013 Indonesia", "ga": "Iiri", "ga-ie": "Iiri \u2013 Irlanti", "it": "Italia", "it-it": "Italia \u2013 Italia", "it-ch": "Italia \u2013 Sveitsi", "ja": "Japani", "ja-jp": "Japani \u2013 Japani", "kn": "Kannada", "kk": "Kazakki", "kok": "Konkani", "ko": "Korea", "ko-kr": "Korea \u2013 Etel\xE4-Korea", "ku": "Kurdi", "ky": "Kirgiisi", "ky-kg": "Kirgiisi", "lo": "Lao", "lv": "Latvia", "lv-lv": "Latvia \u2013 Latvia", "lt": "Liettua", "lt-lt": "Liettua \u2013 Liettua", "mk": "Makedonia", "mk-mk": "Makedonia \u2013 Makedonia", "ml": "Malajalami", "ms": "Malaiji", "ms-bn": "Malaiji \u2013 Brunei", "ms-my": "Malaiji \u2013 Malesia", "mt": "Malta", "mt-mt": "Malta \u2013 Malta", "mr": "Marathi", "mn": "Mongoli", "my": "Burma", "my-mm": "Burma \u2013 Myanmar (Burma)", "ne": "Nepali", "no": "Norja", "nb": "Norja, kirjanorja", "nb-no": "Norja Bokmal - Norja", "no-no": "Norja \u2013 Norja", "pl": "Puola", "pl-pl": "Puola \u2013 Puola", "pt": "Portugali", "pt-br": "Portugali \u2013 Brasilia", "pt-pt": "Portugali \u2013 Portugali", "pa": "Punjabi", "pa-in": "Punjabi - Intia", "pa-pk": "Punjabi \u2013 Pakistan", "ro": "Romania", "ro-ro": "Romania \u2013 Romania", "ru": "Ven\xE4j\xE4", "ru-ru": "Ven\xE4j\xE4 \u2013 Ven\xE4j\xE4", "rw-rw": "Kinyarwanda", "sa": "Sanskrit", "si": "Sinhala", "sr": "Serbia", "sr-ba": "Serbia \u2013 Bosnia ja Hertsegovina", "sr-me": "Serbia \u2013 Montenegro", "sr-rs": "Serbia \u2013 Serbia", "sr-cs": "Serbia \u2013 Serbia ja Montenegro (entinen)", "sk": "Slovakki", "sk-sk": "Slovakki \u2013 Slovakia", "sl": "Slovenia", "sl-si": "Sloveeni \u2013 Slovenia", "es": "espanja", "es-ar": "Espanja \u2013 Argentiina", "es-bo": "Espanja \u2013 Bolivia", "es-cl": "Espanja \u2013 Chile", "es-co": "Espanja \u2013 Kolumbia", "es-cr": "Espanja \u2013 Costa Rica", "es-cu": "Espanja \u2013 Kuuba", "es-do": "Espanja \u2013 Dominikaaninen tasavalta", "es-ec": "Espanja \u2013 Ecuador", "es-sv": "Espanja \u2013 El Salvador", "es-gt": "Espanja \u2013 Guatemala", "es-hn": "Espanja \u2013 Honduras", "es-mx": "Espanja - Meksiko", "es-ni": "Espanja \u2013 Nicaragua", "es-pa": "Espanja \u2013 Panama", "es-py": "Espanja \u2013 Paraguay", "es-pe": "Espanja \u2013 Peru", "es-pr": "Espanja \u2013 Puerto Rico", "es-es": "Espanja \u2013 Espanja", "es-us": "Espanja \u2013 Yhdysvallat", "es-uy": "Espanja \u2013 Uruguay", "es-ve": "Espanja \u2013 Venezuela", "sw": "Swahili", "sv": "Ruotsi", "sv-fi": "Ruotsi \u2013 Suomi", "sv-se": "Ruotsi \u2013 Ruotsi", "sy": "Syyria", "ta": "Tamili", "tt": "Tataari", "te": "Telugu", "th": "Thai", "th-th": "Thai \u2013 Thaimaa", "tl": "Tagalog", "tr": "Turkki", "tr-tr": "Turkki \u2013 Turkki", "uk": "Ukraina", "uk-ua": "Ukraina \u2013 Ukraina", "ur": "Urdu", "uz": "Uzbekki", "vi": "Vietnam", "vi-vn": "Vietnam \u2013 Vietnam", "yi": "Jiddish", "zu": "Zulu" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "af": "static-1.161",
    "ar-eg": "static-1.161",
    "ar-sa": "static-1.161",
    "ar": "static-1.161",
    "be": "static-1.161",
    "bg": "static-1.161",
    "bn": "static-1.161",
    "ca-es": "static-1.161",
    "ca": "static-1.161",
    "cs": "static-1.161",
    "da": "static-1.161",
    "de": "static-1.161",
    "el": "static-1.161",
    "en-gb": "static-1.161",
    "en": "static-1.161",
    "es-ar": "static-1.161",
    "es-es": "static-1.161",
    "es-mx": "static-1.161",
    "es": "static-1.161",
    "et": "static-1.161",
    "eu": "static-1.161",
    "fi": "static-1.161",
    "fr-ca": "static-1.161",
    "fr": "static-1.161",
    "gl": "static-1.161",
    "gu": "static-1.161",
    "he-il": "static-1.161",
    "he": "static-1.161",
    "hi": "static-1.161",
    "hr": "static-1.161",
    "hu": "static-1.161",
    "hy": "static-1.161",
    "id": "static-1.161",
    "is": "static-1.161",
    "it": "static-1.161",
    "ja": "static-1.161",
    "ka": "static-1.161",
    "kk": "static-1.161",
    "kn": "static-1.161",
    "ko": "static-1.161",
    "ky": "static-1.161",
    "lt": "static-1.161",
    "lv": "static-1.161",
    "mk": "static-1.161",
    "mn": "static-1.161",
    "mr": "static-1.161",
    "ms-my": "static-1.161",
    "ms": "static-1.161",
    "nl-be": "static-1.161",
    "nl-nl": "static-1.161",
    "nl": "static-1.161",
    "no": "static-1.161",
    "pl": "static-1.161",
    "pt-br": "static-1.161",
    "pt-pt": "static-1.161",
    "ro": "static-1.161",
    "ru": "static-1.161",
    "sk": "static-1.161",
    "sl": "static-1.161",
    "sq": "static-1.161",
    "sr": "static-1.161",
    "sv": "static-1.161",
    "sw": "static-1.161",
    "ta": "static-1.161",
    "te": "static-1.161",
    "th": "static-1.161",
    "tl": "static-1.161",
    "tr": "static-1.161",
    "uk": "static-1.161",
    "ur": "static-1.161",
    "vi": "static-1.161",
    "zh-cn": "static-1.161",
    "zh-hans": "static-1.161",
    "zh-hant": "static-1.161",
    "zh-hk": "static-1.161",
    "zh-tw": "static-1.161"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "fi": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} vrk", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "days": "{{ days }} vrk", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min" } }, "dateTime": { "quarterAndYear": "K{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, alanro {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "fi": "static-7.1359"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1359",
    "ar-eg": "static-7.1359",
    "bg": "static-7.1359",
    "bn": "static-7.1359",
    "ca-es": "static-7.1359",
    "cs": "static-7.1359",
    "da": "static-7.1359",
    "de": "static-7.1359",
    "el": "static-7.1359",
    "en-gb": "static-7.1359",
    "en": "static-7.1359",
    "es-mx": "static-7.1359",
    "es": "static-7.1359",
    "et": "static-7.1359",
    "fi": "static-7.1359",
    "fr-ca": "static-7.1359",
    "fr": "static-7.1359",
    "he-il": "static-7.1359",
    "hi": "static-7.1359",
    "hr": "static-7.1359",
    "hu": "static-7.1359",
    "id": "static-7.1359",
    "it": "static-7.1359",
    "ja": "static-7.1359",
    "ko": "static-7.1359",
    "lt": "static-7.1359",
    "ms": "static-7.1359",
    "nl": "static-7.1359",
    "no": "static-7.1359",
    "pl": "static-7.1359",
    "pt-br": "static-7.1359",
    "pt-pt": "static-7.1359",
    "ro": "static-7.1359",
    "ru": "static-7.1359",
    "sk": "static-7.1359",
    "sl": "static-7.1359",
    "sv": "static-7.1359",
    "th": "static-7.1359",
    "tl": "static-7.1359",
    "tr": "static-7.1359",
    "uk": "static-7.1359",
    "vi": "static-7.1359",
    "x-pseudo": "static-7.1359",
    "zh-cn": "static-7.1359",
    "zh-hk": "static-7.1359",
    "zh-tw": "static-7.1359"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fi', {version: 'static-7.1359'}); }
})();



(function() {
  var result = { translations: { "fi": { "videoPlayer": { "htmlTitle": "HubSpot-video", "htmlTitleWithVideo": "{{ videoTitle }} | HubSpot Video", "controls": { "audioPlayer": "Soitin", "videoPlayer": "Videosoitin", "play": "Toista", "playVideo": "Toista video", "pause": "Keskeyt\xE4", "replay": "Toista", "currentTime": "Nykyinen aika", "duration": "Kesto", "remainingTime": "Aika j\xE4ljell\xE4", "fullscreen": "Koko n\xE4ytt\xF6", "exitFullscreen": "Poistu koko n\xE4yt\xF6n tilasta", "mute": "Mykist\xE4", "unmute": "Poista mykistys", "volumeLevel": "\xC4\xE4nenvoimakkuus", "captions": "Kuvatekstit", "captionsOff": "Pois p\xE4\xE4lt\xE4", "seekBar": "S\xE4\xE4d\xE4 sijaintia", "chapter": "Kappale", "elapsedTime": "Kulunut aika: {{timeDisplay}}" }, "playbackOptions": { "buttonTitle": "Toistovaihtoehdot", "playbackRate": "Toistonopeus:", "quality": "Laatu:", "normal": "Normaali", "auto": "(automaattinen)" }, "formModal": { "defaultThankYouMessage": "Kiitos vastauksestasi.", "inlineMessageButton": "Katso video" }, "ctaModal": { "imgAlt": "Videon toimintakehotus" }, "errors": { "generic": { "heading": "Videon lataus ei onnistunut" }, "UNAUTHORIZED": { "heading": "Video ei k\xE4yt\xF6ss\xE4" }, "VIDEO_NOT_FOUND": { "heading": "Videota ei l\xF6ytynyt" }, "INVALID_URL": { "heading": "Videota ei l\xF6ytynyt" }, "UNSUPPORTED_EMBED": { "heading": "Video ei saatavilla", "extra": "T\xE4t\xE4 videota ei voi katsoa ulkopuolelta." }, "refreshLink": "Yrit\xE4 uudelleen" } } } } };
  result.translationsLoaded = {
  "video-player-ui": {
    "fi": "static-1.29208"
  }
};
  result.translationsAvailable = {
  "video-player-ui": {
    "af": "static-1.29208",
    "ar-eg": "static-1.29208",
    "bg": "static-1.29208",
    "bn": "static-1.29208",
    "ca-es": "static-1.29208",
    "cs": "static-1.29208",
    "da": "static-1.29208",
    "de": "static-1.29208",
    "el": "static-1.29208",
    "en-gb": "static-1.29208",
    "en": "static-1.29208",
    "es-mx": "static-1.29208",
    "es": "static-1.29208",
    "et": "static-1.29208",
    "fi": "static-1.29208",
    "fr-ca": "static-1.29208",
    "fr": "static-1.29208",
    "he-il": "static-1.29208",
    "hi": "static-1.29208",
    "hr": "static-1.29208",
    "hu": "static-1.29208",
    "id": "static-1.29208",
    "it": "static-1.29208",
    "ja": "static-1.29208",
    "ko": "static-1.29208",
    "lt": "static-1.29208",
    "ms": "static-1.29208",
    "nl": "static-1.29208",
    "no": "static-1.29208",
    "pl": "static-1.29208",
    "pt-br": "static-1.29208",
    "pt-pt": "static-1.29208",
    "ro": "static-1.29208",
    "ru": "static-1.29208",
    "sk": "static-1.29208",
    "sl": "static-1.29208",
    "sv": "static-1.29208",
    "th": "static-1.29208",
    "tl": "static-1.29208",
    "tr": "static-1.29208",
    "uk": "static-1.29208",
    "vi": "static-1.29208",
    "zh-cn": "static-1.29208",
    "zh-hk": "static-1.29208",
    "zh-tw": "static-1.29208"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:video-player-ui:fi', {version: 'static-1.29208'}); }
})();


